export const NFT_COLLECTION_MUMBAI_CONTRACT = '0x4BD7e7F8f3ae7deC1EfDf79D8B540ECd9157116F'
